<template>
    <div>
         <!-- ====== Team Start ====== -->
    <section id="team" class="ch-gw-team" style="padding-top: 1rem;">
      <div class="container m_container ch-gw-animation">
        <div class="row">
          <div class="col-lg-12">
            <div  style="max-width: 100%;margin: 0 auto;padding-top: 3rem;" v-html="content">

            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- ====== Team End ====== -->
    </div>
</template>
<script>
import {queryIntroduce } from "@/utils/gw";
export default {
  components:{

  },
  name: 'introduce',
  data () {
    return {
      content:''
    }
  },
  mounted() {
    this.queryIntroduce()
  },
  methods:{
    queryIntroduce(){
      queryIntroduce().then((e)=>{
        console.log(e.data.introduce[0])
        this.content = e.data.introduce[0].content.replaceAll("/dev-api",this.$resources)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/about/introduce.vue